/**
 * Hide very long author's description
 * Add 'Show more' toggle
 */
(function($){
    const $authorDescr = $('.author__info-descr'),
        $authorDescrToggle = $('.author__info-descr-btn-toggle')

    if ( $authorDescr.outerHeight() > 103 ) {
        $authorDescr.addClass('_hidden')
    }

    $authorDescrToggle.on('click', function(){
        $authorDescr.toggleClass('_expanded')
    })
})(jQuery)